import styled from 'styled-components';

export const StyledLayout = styled.main`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  margin: 0 auto;
  max-width: 960px;
  padding: 0;

  textarea,
  textarea.up-input {
    background-color: #ffffff !important;
    color: #000000 !important;
    border: 1px solid #000000 !important;
    font-family: Arial, Helvetica, sans-serif;
  }

  .submit-button,
  .submit-button label {
    color: #000000 !important;
  }
`;
